<template>
    <div style="padding:10px;">
        <api-root-page></api-root-page>
    </div>
</template>

<script>
    import { $ } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import ApiRootPage from '../../compo/apiDoc/ApiRootPage.vue';

    export default {
        components: {
            ApiRootPage
        },
        data: function () {
            return {
                forAll: true
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/entry/apiDoc/main.vue